module.exports = __webpack_public_path__ + "img/qr_sample.jpg";